import React from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../maintenance/Maintenance.css";
import Component1 from "../service_common_components/component1/Component1";
import Component2 from "../service_common_components/component2/Component2";
import Component3 from "../service_common_components/component3/Component3";

const Pickup = () => {
  return (
    <section className="Pickup service">
      <Container>
        <h4 className="service_title">Pickup & Drop-off Service</h4>


        <Component1
          title1="Convenience at Your"
          title2="Doorstep"
          title3="Experience the ultimate convenience with our Pickup & Drop-off Service. We make it easy for you to have your items collected and delivered without ever leaving your home or office. Whether it’s laundry, groceries, packages, or vehicles, our professional team ensures everything is picked up safely and delivered on time. With reliable scheduling, careful handling, and prompt service, you can trust us to take the stress out of transportation. Perfect for busy professionals, families, or anyone who values convenience, our service is designed to make your life simpler, easier, and worry-free. Let us handle the logistics while you focus on what truly matters.Life is busy, and every minute counts. That’s why our Pickup & Drop-off Service is designed to make your day easier. From the moment you schedule a pickup, we take care of everything — collecting your items from your doorstep and delivering them safely to their destination. Whether it’s laundry that needs fresh care, groceries for the week, important documents, or even vehicles, we handle each item with the utmost care and attention."
          imgSrc="/assets/images/services/pickup.png"
        />


        <Component2
          title="Service Process"
          tips={[
            "Return the vehicle to your desired location once the service is completed.",
            "Conduct a thorough inspection to ensure all services are completed to standard.",
            "Your vehicle is taken to the service center for inspection, repair, or maintenance as requested.",
            "Our professional team collects your vehicle from the specified location safely.",
            "Receive confirmation with the pickup time, location, and service details."
          ]}
          list={true}
        />


        <Component2
          title="Benefits of Doorstep Service"
          tips={[
            "Reduces the hassle of coordinating vehicle maintenance on your own.",
            "Book services at a time that suits your routine.",
            "Trained staff ensures your vehicle is picked up, serviced, and returned safely.",
            "Eliminates the need to travel to and wait at a service center.",
            "Get your vehicle serviced without leaving your home or office."
          ]}
          list={true}
        />


        <Component3
          title="Maintenance Tips"
          tips={[
            "Inform the service team of any unusual sounds, leaks, or performance issues for timely intervention.",
            "Keep your battery in good condition to avoid breakdowns.",
            "Monitor tire pressure and tread to prevent wear and enhance safety.",
            "Ensure engine oil, coolant, and other fluids are topped up before each service.",
            "Maintain a log of all services and repairs for reference and resale value."
          ]}
          list={true}
        />
      </Container>
    </section>
  );
};

export default Pickup;
